import React, { useContext, useState, useEffect } from 'react';
import { Card, Button, Table } from 'react-bootstrap';

// Icon
import Icon from '@mdi/react';
import { mdiSquareEditOutline, mdiTrashCanOutline } from '@mdi/js';
import { toast } from 'react-toastify';
import { IncomeProvider, useIncome } from './getIncome';
import { IncomeContext1 } from './incomeContext';
import { getFromAPI,postToAPI,putToAPI,deleteFromAPI,formatISODateWithTimezone,handleDateFormat,showAlert,formatDate } from '../../../Utils/utils';
import  messages from '../../../Utils/lang';
import FormModal from '../../../Utils/FormModal';

export default function ViewIncomeCategory({setIncomeCategoryId}) {
    // Default Modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const incomeCategoryId = useContext(IncomeContext1)
    const { incomCategoryeData, fetchIncomeData } = useIncome();
    const [tableData, setTableData] = useState([]); // Initialize state with an empty array

    const initialInputData = {
        category_name: '',
        description: '',
        isexpense: 0,
        created_branch_id: 0,
        created_user_id: 0,
        last_modfied_user_id: 0,
        created_date_time: formatISODateWithTimezone(new Date()),
        last_modified_date_time: formatISODateWithTimezone(new Date()),
        isdeleted: 0
    }
    const [inputData, setInputData] = useState({ ...initialInputData });


    useEffect(() => {
        const fetchIncomeCategoryDetails = async () => {
            try {
                const response = await getFromAPI(`FtsExpenseCategory/?id=${incomeCategoryId}`);
                if (response && response.length > 0) {
                    const fetchedData = response[0];
                    setInputData({
                        category_name: fetchedData.category_name,
                        description: fetchedData.description
                    });
                }
            } catch (error) {
                return null;
            }
        };

        if (incomeCategoryId) {
            fetchIncomeCategoryDetails();
        }
    }, [incomeCategoryId]);

    const fetchIncomeCategoryTable = async () => {
        try {
            const response = await getFromAPI(`FtsExpenseCategory/?id=${incomeCategoryId}`);

            // Map API response to match the table data structure
            const mappedData = [
                { tableheading1: "Name :", tablesubtext1: response[0].category_name},
                { tableheading1: "Description :", tablesubtext1: response[0].description},
                { tableheading1: "Created User Id :", tablesubtext1: response[0].created_user_id},
                { tableheading1: "Created Date :", tablesubtext1: formatDate(response[0].created_date_time.replace('T', ' ').replace('Z', '')) }


            ]

            setTableData(mappedData); // Update state with the mapped data
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        fetchIncomeData();
        fetchIncomeCategoryTable();
    }, [incomeCategoryId]);

    const handleDeleteIncomeCategory = async (itemId) => {
        try {
            const response = await deleteFromAPI(`FtsExpenseCategory/${itemId}/`);
            if (response) {
                toast.success("Income category deleted successfully",'success');
                fetchIncomeData(); // Update the customer list
                if(incomCategoryeData.length>0){
                    setIncomeCategoryId(incomCategoryeData[0].id);
                }
                else
                {
                    setIncomeCategoryId('');
                }
            }
        } catch (error) {
            return null;
        }

    };

    // Handle Delete Expense Category Entry
    const handleDelete = async (Id) => {
        try {
            showAlert('Are you sure you want to delete this Income Category?', 'confirm', (result) => {
                if (result) {
                    // User confirmed the deletion
                    handleDeleteIncomeCategory(Id);
                } else {
                    // User canceled the deletion
                    // You can handle this case if needed
                }
            });
        } catch (error) {
            return null;
        }
    };

    const handleEdit = () => {
        setShow(true);
    };

    const handleSaveChanges = async () => {
         if (!inputData.category_name || !inputData.category_name.trim()) {
                toast.error(messages.incomeCategory.required_category_name);
                return;
            }
        if (!inputData.description || !inputData.description.trim()) {
                toast.error(messages.incomeCategory.required_description);
                return;
            }
        
        const isExists = Array.isArray(incomCategoryeData) && incomCategoryeData.find(income => 
            income.category_name.trim() === inputData.category_name.trim() &&
            income.id !== incomeCategoryId // Exclude the current branch being edited
        );
        
        if (isExists) {
            toast.error(messages.incomeCategory.already_exist);
                return;
            }
            
        try {
            await putToAPI(`FtsExpenseCategory/${incomeCategoryId}/`, inputData);
            toast.success(messages.incomeCategory.updated_successfully);
            setShow(false);
            fetchIncomeData();
            fetchIncomeCategoryTable();
        } catch (error) {
            return null;
        }
    };

    const handleInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setShow(false);
    };

    const rows = [
        {
            columns: [
                { size: { lg: 12 }, label: 'Income Category Name', type: 'text', name: 'category_name', id: 'category_name', placeholder: 'Enter expense Category Name...', value: inputData.category_name, errormsg: '', },
                { size: { lg: 12 }, label: 'Income Description', type: 'textarea', rows: 4, name: 'description', id: 'description', placeholder: 'Type expense description...', value: inputData.description, errormsg: '', },
            ]
        }
    ];
    const Buttons = [
        { variant: "primary", text: "Update", onClick: handleSaveChanges },
        { variant: "secondary", text: "Cancel", onClick: handleClose },
    ]


    return (
        <>
            <Card className='right-content-details'>
                <Card.Body>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <Card.Title className='mb-0'>View Unit</Card.Title>
                        <div className='d-flex gap-3'>
                            <Button variant="soft-info p-0" onClick={handleEdit} disabled={!incomeCategoryId}>
                                <div className='avatar avatar-sm'>
                                    <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                                </div>
                            </Button>{' '}
                            <Button variant="soft-danger p-0" onClick={() => handleDelete(incomeCategoryId)} disabled={!incomeCategoryId}>
                                <div className='avatar avatar-sm'>
                                    <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                                </div>
                            </Button>{' '}
                        </div>
                    </div>

                    <Table responsive className='table-lg border table-nowrap mb-0'>
                        <tbody>
                            {tableData.map((data, i) =>
                                <tr key={i}>
                                    <th>{data.tableheading1}</th>
                                    <td>{data.tablesubtext1}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* From Modal */}
            <FormModal title="Edit Expense Category" formModalShow={show} Buttons={Buttons} handleFormModalClose={handleClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>
    )
}
